import logger from 'pino';
import { useMagnolia } from '~/composables/custom/useMagnolia/useMagnolia';

const loggerInstance = logger({
  formatters: {
    level(label) {
      return { level: label };
    },
  },
});

interface AdditionalInfo {
  [key: string]: string | undefined;
}

export const useCustomLogger = () => {
  const { $domain } = useNuxtApp();
  const { atMagnolia } = useMagnolia();

  const log = (level: logger.LevelWithSilentOrString, error: string | Error, additionalInfo?: AdditionalInfo) => {
    if (!atMagnolia.value && import.meta.client && process.env.NODE_ENV === 'production') {
      return;
    }

    // @ts-expect-error - pino typings are incorrect
    loggerInstance[level]({
      component: 'storefront',
      message: error instanceof Error ? error.message : error,
      ...(additionalInfo ? { additionalInfo: additionalInfo } : {}),
      timeStamp: new Date().toISOString(),
      country: $domain.countryCode,
      ...(error instanceof Error ? { stack: error.stack } : {}),
    });
  };

  return {
    error: (error: string | Error, additionalInfo?: AdditionalInfo) => log('error', error, additionalInfo),
    info: (message: string, additionalInfo?: AdditionalInfo) => log('info', message, additionalInfo),
    warn: (error: string, additionalInfo?: AdditionalInfo) => log('warn', error, additionalInfo),
    debug: (error: string, additionalInfo?: AdditionalInfo) => log('debug', error, additionalInfo),
  };
};
